import React from "react";
import api from "../../api/axios";

const ProjectJsonImporter = ({ inputId, onImportComplete }) => {

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const text = await file.text();
      const json = JSON.parse(text);

      await api.post("/project/import", json);

      onImportComplete?.();

      alert("Project imported successfully ✅");
    } catch (err) {
      console.error("Import failed:", err);
      alert("Import failed ❌");
    }

    // reset input (important!)
    e.target.value = "";
  };

  return (
    <input
      id={inputId}
      type="file"
      accept="application/json"
      style={{ display: "none" }}
      onChange={handleFileChange}
    />
  );
};

export default ProjectJsonImporter;